/* eslint-disable react/jsx-no-bind */
import PropTypes from 'prop-types';
import React, { createRef, Fragment, Suspense } from 'react';
import classNames from 'classnames';

import i18n from '../../i18n';
import Home from '../home/Home';
import User from '../../models/User';
import HomeFake from '../home/HomeFake';
import FiltersModel from '../../models/Filters';
import Loading from '../common/Loading';
import Icons from '../../utils/Icons';
import Utils from '../../utils/utils';
import PushAlert from './PushAlert';
import {
    NOT_CREATED_ALERT,
    CREATED_ALERT,
    CREATED_ALERT_LABEL_INVISIBLE,
    hasAlreadyCreatedAlert
} from '../../models/PushAlert';
import Alert from '../../models/Alert';
import Push from './Push';
import Screen from '../../utils/Screen';

const ActiveFilters = React.lazy(() => import('./ActiveFilters'));
export default class Results extends React.Component {
    static propTypes = {
        results: PropTypes.array,
        alerts: PropTypes.arrayOf(PropTypes.instanceOf(Alert)),
        user: PropTypes.instanceOf(User),
        filters: PropTypes.object.isRequired,
        showPushAlert: PropTypes.bool,
        showPushReferral: PropTypes.bool,
        excludeFilters: PropTypes.arrayOf(PropTypes.string),
        unZoom: PropTypes.func,
        homeRollOver: PropTypes.func,
        isLogged: PropTypes.bool,
        homeRollOut: PropTypes.func,
        queryString: PropTypes.string,
        onRemoveFilter: PropTypes.func,
        onUpdateFlexibility: PropTypes.func,
        addAlert: PropTypes.func
    };

    static defaultProps = {
        results: null
    };

    constructor(props) {
        super(props);
        this.unzoomSearchMap = this.unzoomSearchMap.bind(this);
        this.setExperience = this.setExperience.bind(this);
        this.handleOnPushAlert = this.handleOnPushAlert.bind(this);
        this.setCreatedAlertStatus = this.setCreatedAlertStatus.bind(this);
        this.resultRef = createRef();
        this.state = {
            error: this.getError(props.results),
            loading: false,
            abTest: false,
            createdAlertStatus: NOT_CREATED_ALERT
        };
    }

    componentDidMount() {
        const { alerts, queryString } = this.props;

        if (alerts) {
            this.setCreatedAlertStatus(
                hasAlreadyCreatedAlert(alerts, queryString)
                    ? CREATED_ALERT_LABEL_INVISIBLE
                    : NOT_CREATED_ALERT
            );
        } else {
            this.setCreatedAlertStatus(NOT_CREATED_ALERT);
        }
        this.setExperience();
    }

    componentDidUpdate(prevProps) {
        const { alerts, queryString } = this.props;

        if (queryString !== prevProps.queryString) {
            if (alerts) {
                this.setCreatedAlertStatus(
                    hasAlreadyCreatedAlert(alerts, queryString)
                        ? CREATED_ALERT_LABEL_INVISIBLE
                        : NOT_CREATED_ALERT
                );
            } else {
                this.setCreatedAlertStatus(NOT_CREATED_ALERT);
            }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        // reset error state on each results update
        this.setState({
            error: this.getError(nextProps.results)
        });
    }

    setCreatedAlertStatus(status) {
        this.setState({ createdAlertStatus: status });
    }

    setExperience() {
        const isPhotoBlockActive = Utils.isPhotoBlocked(this.props.user);

        if (isPhotoBlockActive) {
            this.setState({ abTest: isPhotoBlockActive });
        }
    }

    getError(results) {
        if (Array.isArray(results) && results.length === 0) {
            return i18n.t('search:search_noresults');
        }
        return null;
    }

    loading(show) {
        if (show) {
            this.setState({
                loading: true
            });
        } else {
            this.setState({
                loading: false
            });
        }
    }

    static removeSearchFilters(e) {
        e.preventDefault();
        const resetFilter = $('a.reset-filters');
        if (resetFilter[0]) {
            resetFilter[0].click();
        }
    }

    static removeDestinationInSearchBar(e) {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('clear-search-location'));
    }

    unzoomSearchMap(e, scale) {
        e.preventDefault();
        this.props.unZoom(scale);
    }

    flexibilityIsLowerThan(flexibility, value) {
        if (!flexibility) {
            return true;
        }

        return flexibility < value;
    }

    handleOnPushAlert(filters) {
        const { isLogged, queryString, addAlert } = this.props;
        const alert = Alert.fromSearch(queryString, filters);

        if (!isLogged) {
            const event = new CustomEvent('open_signin_popup', {
                detail: { onLogin: () => addAlert(alert) }
            });
            document.dispatchEvent(event);
        } else {
            addAlert(alert).then(() => this.setCreatedAlertStatus(CREATED_ALERT));
        }
    }

    handlePushAlert(filtersFromUrl, style) {
        const { queryString, filters } = this.props;
        const hasCollectionFilter = filters.luxury;

        if (!queryString) {
            return null;
        }

        if (hasCollectionFilter) {
            return this.displayPushCollection(filtersFromUrl, style);
        }

        return this.displayPushAlert(filtersFromUrl, style);
    }

    displayCheckNonCollectionHomes() {
        const { onRemoveFilter } = this.props;

        return (
            <Push
                className="push-regular-homes"
                title={i18n.t('search:no-results.check-non-collection-homes.title')}
                text={i18n.t('search:no-results.check-non-collection-homes.text')}
                renderIcon={() => (
                    <img
                        className="push-img hidden-xs"
                        src={`${Utils.getCloudfrontDomain()}/images/website/logo/he-logo.svg`}
                    />
                )}
                renderButton={() => (
                    <button className="push-button btn btn-default" onClick={() => onRemoveFilter('luxury')}>
                        {i18n.t('search:no-results.check-non-collection-homes.button')}
                    </button>
                )}
            />
        );
    }

    displayPushAlert(filters, props, iconClassName = '') {
        const { user } = this.props;
        const { createdAlertStatus } = this.state;
        const { queryString } = this.props;
        const renderIcon = () => {
            return user?.get('is_he_collection') ? (
                <span className={`${iconClassName} push-icon no-results-icon icon-collection-create-alert`}>
                    {Icons.transform(7)}
                </span>
            ) : (
                <img
                    className="push-icon no-results-icon blue-alert"
                    src={`${Utils.getCloudfrontDomain()}/images/website/search/create_alert.svg`}
                />
            );
        };

        return (
            filters.location.polygon && (
                <PushAlert
                    title={i18n.t('search:no-results.alert-title')}
                    text={i18n.t('search:no-results.alert-text', {
                        location: `<span class="push-alert-text-location">${queryString}</span>`
                    })}
                    /* eslint-disable-next-line react/jsx-no-bind */
                    renderIcon={renderIcon}
                    status={createdAlertStatus}
                    /* eslint-disable-next-line react/jsx-no-bind */
                    onPush={() => this.handleOnPushAlert(filters)}
                    {...props}
                />
            )
        );
    }

    displayPushCollection(filters, props) {
        const { createdAlertStatus } = this.state;

        const renderIcon = () => (
            <img
                className="push-collection-img"
                src={`${Utils.getCloudfrontDomain()}/images/website/collection/search-warning-more-collection.svg`}
            />
        );

        return (
            filters.location.polygon && (
                <PushAlert
                    text={i18n.t('search:push.collection.text')}
                    /* eslint-disable-next-line react/jsx-no-bind */
                    renderIcon={renderIcon}
                    status={createdAlertStatus}
                    /* eslint-disable-next-line react/jsx-no-bind */
                    onPush={() => this.handleOnPushAlert(filters)}
                    {...props}
                />
            )
        );
    }

    displayPushReferral(props) {
        const { user } = this.props;
        const renderIcon = () => {
            return user?.get('is_he_collection') ? (
                <span className="push-icon icon-collection-referral-push">{Icons.transform(28)}</span>
            ) : (
                <img
                    className="push-icon beats-love"
                    src={`${Utils.getCloudfrontDomain()}/images/website/search/alert.svg`}
                />
            );
        };

        const renderButton = () => (
            <a
                className="push-button btn btn-default"
                href={i18n.t('url:sponshorship')}
                target="_blank"
                rel="noopener noreferrer"
            >
                {i18n.t('common:invite-friends')}
            </a>
        );

        return (
            <Push
                className="push-referral search-result col-sm-6"
                title={i18n.t('search:push.sponsorship.title')}
                text={i18n.t('search:push.sponsorship.text')}
                /* eslint-disable-next-line react/jsx-no-bind */
                renderIcon={renderIcon}
                /* eslint-disable-next-line react/jsx-no-bind */
                renderButton={renderButton}
                {...props}
            />
        );
    }

    render() {
        const { loading, createdAlertStatus } = this.state;
        const { isLogged, filters, excludeFilters, showPushAlert, showPushReferral, user } = this.props;

        if (loading) {
            return <Loading />;
        }

        const activeFilters = FiltersModel.fromFlatFilters(filters, excludeFilters).getFiltersList();
        const filtersFromUrl = FiltersModel.fromUrl().toJSON();

        const searchResultsClasses = classNames({
            'search-results': true,
            row: true,
            'no-results': this.state.error
        });

        return (
            <div className={searchResultsClasses} ref={this.resultsRef}>
                {(() => {
                    if (this.state.error) {
                        return (
                            <div className="no-results-container">
                                <img
                                    className="no-result-illustration"
                                    src={`${Utils.getCloudfrontDomain()}/images/website/${
                                        user && user.get('is_he_collection')
                                            ? 'collection/no-search-results.svg'
                                            : 'home_page/no_search_results.svg'
                                    }`}
                                />

                                <div className="no-results">
                                    <div className="no-results-title-container">
                                        <span
                                            className="no-results-title"
                                            dangerouslySetInnerHTML={{
                                                __html: i18n.t('search:no-results.title')
                                            }}
                                        />
                                        <span className="no-results-subtitle">
                                            {i18n.t('search:no-results.subtitle')}
                                        </span>
                                    </div>

                                    <ul>
                                        {user &&
                                            (Utils.getParameter('collection', false) ||
                                                Utils.getParameter('luxury', false)) && (
                                                <li className="no-results-choice">
                                                    {this.displayCheckNonCollectionHomes()}
                                                </li>
                                            )}

                                        {createdAlertStatus !== CREATED_ALERT_LABEL_INVISIBLE &&
                                            filtersFromUrl.location.polygon && (
                                                <li className="no-results-choice">
                                                    {this.displayPushAlert(
                                                        filtersFromUrl,
                                                        {
                                                            onHide: () =>
                                                                this.setCreatedAlertStatus(
                                                                    CREATED_ALERT_LABEL_INVISIBLE
                                                                )
                                                        },
                                                        'hidden-xs'
                                                    )}
                                                </li>
                                            )}

                                        <li className="no-results-choice">
                                            <span
                                                className={`no-results-icon hidden-xs ${
                                                    user && user.get('is_he_collection')
                                                        ? 'icon-collection-expand-search'
                                                        : 'icon-expand_search'
                                                }`}
                                            >
                                                {Icons.transform(8)}
                                            </span>

                                            <div className="no-results-choice-content">
                                                <span className="no-results-choice-text-title">
                                                    {i18n.t('search:no-results.expand-search-title')}
                                                </span>
                                                <p className="no-results-choice-text">
                                                    {i18n.t('search:no-results.expand-search-text')}:
                                                    {/* eslint-disable-next-line react/jsx-no-bind */}
                                                    <span
                                                        className="no-results-choice-km-label"
                                                        onClick={(e) => this.unzoomSearchMap(e, 0.5)}
                                                    >
                                                        {i18n.t('search:no-results.expand-search-km', {
                                                            value: 10
                                                        })}
                                                    </span>
                                                    {/* eslint-disable-next-line react/jsx-no-bind */}/{' '}
                                                    <span
                                                        className="no-results-choice-km-label"
                                                        onClick={(e) => this.unzoomSearchMap(e, 1)}
                                                    >
                                                        {i18n.t('search:no-results.expand-search-km', {
                                                            value: 25
                                                        })}
                                                    </span>
                                                    {/* eslint-disable-next-line react/jsx-no-bind */}/{' '}
                                                    <span
                                                        className="no-results-choice-km-label"
                                                        onClick={(e) => this.unzoomSearchMap(e, 1.5)}
                                                    >
                                                        {i18n.t('search:no-results.expand-search-km', {
                                                            value: 50
                                                        })}
                                                    </span>
                                                </p>
                                            </div>
                                        </li>

                                        {activeFilters.length > 0 && (
                                            <li className="no-results-choice">
                                                <span
                                                    className={`no-results-icon hidden-xs ${
                                                        user && user.get('is_he_collection')
                                                            ? 'icon-collection-remove-filters'
                                                            : 'icon-remove_filters'
                                                    }`}
                                                >
                                                    {Icons.transform(13)}
                                                </span>

                                                <div className="no-results-choice-content">
                                                    <span className="no-results-choice-text-title">
                                                        {i18n.t('search:no-results.remove-filters-title')}
                                                    </span>
                                                    <p className="no-results-choice-text no-results-choice-text-filter">
                                                        {i18n.t('search:no-results.remove-filters-text')}
                                                    </p>
                                                    <Suspense
                                                        fallback={
                                                            <div>{`${i18n.t('common:loading')}...`}</div>
                                                        }
                                                    >
                                                        <ActiveFilters
                                                            filters={filters}
                                                            excludes={excludeFilters}
                                                            removeFilter={this.props.onRemoveFilter}
                                                        />
                                                    </Suspense>
                                                </div>
                                            </li>
                                        )}

                                        {filters.availability &&
                                            filters.availability.date_range &&
                                            filters.availability.date_range.flexibility !== 7 && (
                                                <li className="no-results-choice">
                                                    <span
                                                        className={`no-results-icon hidden-xs ${
                                                            user && user.get('is_he_collection')
                                                                ? 'icon-collection-flexible-dates'
                                                                : 'icon-flexible_dates'
                                                        }`}
                                                    >
                                                        {Icons.transform(16)}
                                                    </span>

                                                    <div className="no-results-choice-content">
                                                        <span className="no-results-choice-text-title">
                                                            {i18n.t('search:no-results.flexible-dates-title')}
                                                        </span>
                                                        <p>
                                                            {i18n.t('search:no-results.flexible-dates-text')}
                                                            {/* eslint-disable-next-line react/jsx-no-bind */}
                                                            {this.flexibilityIsLowerThan(
                                                                filters.availability.date_range.flexibility,
                                                                1
                                                            ) && (
                                                                <span>
                                                                    <span
                                                                        className="no-results-choice-km-label"
                                                                        onClick={() =>
                                                                            this.props.onUpdateFlexibility(1)
                                                                        }
                                                                    >
                                                                        {i18n.t(
                                                                            'search:no-results.flexible-dates-day',
                                                                            { value: 1 }
                                                                        )}
                                                                    </span>{' '}
                                                                    /{' '}
                                                                </span>
                                                            )}
                                                            {/* eslint-disable-next-line react/jsx-no-bind */}
                                                            {this.flexibilityIsLowerThan(
                                                                filters.availability.date_range.flexibility,
                                                                3
                                                            ) && (
                                                                <span>
                                                                    <span
                                                                        className="no-results-choice-km-label"
                                                                        onClick={() =>
                                                                            this.props.onUpdateFlexibility(3)
                                                                        }
                                                                    >
                                                                        {i18n.t(
                                                                            'search:no-results.flexible-dates-day',
                                                                            { value: 3 }
                                                                        )}
                                                                    </span>{' '}
                                                                    /{' '}
                                                                </span>
                                                            )}
                                                            {/* eslint-disable-next-line react/jsx-no-bind */}
                                                            {this.flexibilityIsLowerThan(
                                                                filters.availability.date_range.flexibility,
                                                                7
                                                            ) && (
                                                                <span
                                                                    className="no-results-choice-km-label"
                                                                    onClick={() =>
                                                                        this.props.onUpdateFlexibility(7)
                                                                    }
                                                                >
                                                                    {i18n.t(
                                                                        'search:no-results.flexible-dates-day',
                                                                        { value: 7 }
                                                                    )}
                                                                </span>
                                                            )}
                                                        </p>
                                                    </div>
                                                </li>
                                            )}
                                    </ul>
                                </div>
                            </div>
                        );
                    } else if (
                        _.isEmpty(this.props.results) ||
                        (Array.isArray(this.props.results) && this.props.results.length === 0)
                    ) {
                        return _.range(0, 21).map((i) => (
                            <div key={i} className="search-result col-sm-6">
                                <HomeFake />
                            </div>
                        ));
                    } else {
                        return this.props.results.map((home, index) => {
                            const countResults = this.props.results.length;
                            let height = 'auto';

                            if (this.resultRef.current && !Screen.isMobile()) {
                                ({ height } = this.resultRef.current.getBoundingClientRect());
                            }

                            return (
                                <Fragment key={home.id}>
                                    {showPushReferral &&
                                        index === 3 &&
                                        this.displayPushReferral({ style: { height } })}

                                    {showPushAlert &&
                                        countResults >= 20 &&
                                        index === 19 &&
                                        this.handlePushAlert(filtersFromUrl, {
                                            className: 'search-result col-sm-6',
                                            style: { height }
                                        })}

                                    <div
                                        className={`search-result col-sm-6 ${
                                            home.get('is_collection') ? 'search-result-collection' : ''
                                        }`}
                                        ref={index === 0 ? this.resultRef : undefined}
                                    >
                                        <Home
                                            home={home}
                                            homeRollOver={this.props.homeRollOver}
                                            homeRollOut={this.props.homeRollOut}
                                            isLogged={isLogged}
                                            filters={this.props.filters}
                                            displayCarousel={true}
                                            abTest={this.state.abTest}
                                            source="search-results"
                                        />
                                    </div>

                                    {showPushAlert &&
                                        countResults < 20 &&
                                        countResults - 1 === index &&
                                        this.handlePushAlert(filtersFromUrl, {
                                            className: 'search-result col-sm-6',
                                            style: { height }
                                        })}
                                </Fragment>
                            );
                        });
                    }
                })()}
            </div>
        );
    }
}
